import config from '@frolight/config';
import HTTPStatusError from '@frolight/utils/HTTPStatusError';

const ROOT_URL = `${config.api.uri}/gateway-registration-requests`;

const CREATE_URL = `${ROOT_URL}/`;
const FIND_BY_USER_ID = `${ROOT_URL}/user/:userId`;

export const createGatewayRegistrationRequest = async (abortController, { userId, gatewayId }) => {
  try {
    const response = await fetch(CREATE_URL, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json; charset=UTF-8'
      },
      body: JSON.stringify({
        userId: userId,
        gatewayId: gatewayId
      }),
      signal: abortController.signal
    });

    if (!response.ok) {
      throw new HTTPStatusError(response.status, response.statusText);
    }

    const data = await response.json();
    return data;
  } catch (err) {
    if (err.name !== 'AbortError') {
      throw err;
    }
  }
};

export const findRegistrationRequestsByUserId = async (abortController, { userId }) => {
  try {
    const response = await fetch(FIND_BY_USER_ID.replace(':userId', userId), {
      method: 'GET',
      headers: {
        'Accept': 'application/json'
      },
      signal: abortController.signal
    });

    if (!response.ok) {
      throw new HTTPStatusError(response.status, response.statusText);
    }

    const data = await response.json();
    return data;
  } catch (err) {
    if (err.name !== 'AbortError') {
      throw err;
    }
  }
};
